import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import PublicLayout from "@/components/PublicLayout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Programmes from "@/pages/Programmes";
import Impact from "@/pages/Impact";
import ImpactHub from "@/pages/ImpactHub";
import ImpactProject from "@/pages/ImpactProject";
import MediaCentre from "@/pages/MediaCentre";
import SuccessStories from "@/pages/SuccessStories";import Gallery from "@/pages/Gallery";
import EnterprisePortfolio from "@/pages/EnterprisePortfolio";
import Zimshine from "@/pages/Zimshine";
import WarrenParkConnect from "@/pages/WarrenParkConnect";
import News from "@/pages/News";
import GetInvolved from "@/pages/GetInvolved";
import Donate from "@/pages/Donate";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Safeguarding from "@/pages/Safeguarding";
import CookiePolicy from "@/pages/CookiePolicy";
import TermsOfUse from "@/pages/TermsOfUse";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminSubmissions from "@/pages/admin/AdminSubmissions";
import AdminVolunteers from "@/pages/admin/AdminVolunteers";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";
import AdminIntelligence from "@/pages/admin/AdminIntelligence";
import AdminAnalyticsSettings from "@/pages/admin/AdminAnalyticsSettings";
import AnalyticsLoader from "@/components/AnalyticsLoader";
import Diagnostic from "@/pages/Diagnostic";
import AdminBrandAssets from "@/pages/admin/AdminBrandAssets";
import AdminImpactStats from "@/pages/admin/AdminImpactStats";
import AdminImpactMetrics from "@/pages/admin/AdminImpactMetrics";
import AdminProgrammeFunding from "@/pages/admin/AdminProgrammeFunding";
import AdminProjects from "@/pages/admin/AdminProjects";
import AdminMediaInventory from "@/pages/admin/AdminMediaInventory";
import AdminImpactSnapshot from "@/pages/admin/AdminImpactSnapshot";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminSecurity from "@/pages/admin/AdminSecurity";
import ChangePasswordRequired from "@/pages/admin/ChangePasswordRequired";
import ForgotPassword from "@/pages/admin/ForgotPassword";
import ResetPassword from "@/pages/admin/ResetPassword";
import "@/App.css";

const P = (Comp) => (
    <PublicLayout>
        <Comp />
    </PublicLayout>
);

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Toaster richColors position="top-right" />
                    <AnalyticsLoader />
                    <Routes>
                        {/* Public */}
                        <Route path="/" element={P(Home)} />
                        <Route path="/diagnostic" element={<Diagnostic />} />
                        <Route path="/about" element={P(About)} />
                        <Route path="/programmes" element={P(Programmes)} />
                        <Route path="/impact" element={P(Impact)} />
                        <Route path="/impact-hub" element={P(ImpactHub)} />
                        <Route path="/impact-hub/:slug" element={P(ImpactProject)} />
                        <Route path="/media" element={P(MediaCentre)} />
                        <Route path="/gallery" element={P(Gallery)} />
                        <Route path="/enterprise-portfolio" element={P(EnterprisePortfolio)} />
                        <Route path="/success-stories/zimshine" element={P(Zimshine)} />
                        <Route path="/success-stories" element={P(SuccessStories)} />
                        <Route path="/warren-park-connect" element={P(WarrenParkConnect)} />
                        <Route path="/news" element={P(News)} />
                        <Route path="/get-involved" element={P(GetInvolved)} />
                        <Route path="/donate" element={P(Donate)} />
                        <Route path="/contact" element={P(Contact)} />
                        <Route path="/privacy" element={P(Privacy)} />
                        <Route path="/safeguarding" element={P(Safeguarding)} />
                        <Route path="/cookie-policy" element={P(CookiePolicy)} />
                        <Route path="/terms" element={P(TermsOfUse)} />

                        {/* Admin auth */}
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin/forgot-password" element={<ForgotPassword />} />
                        <Route path="/admin/reset-password" element={<ResetPassword />} />
                        <Route
                            path="/admin/change-password"
                            element={
                                <ProtectedRoute>
                                    <ChangePasswordRequired />
                                </ProtectedRoute>
                            }
                        />

                        {/* Admin */}
                        <Route
                            path="/admin"
                            element={
                                <ProtectedRoute>
                                    <AdminLayout />
                                </ProtectedRoute>
                            }
                        >
                            <Route index element={<AdminDashboard />} />
                            <Route path="submissions" element={<AdminSubmissions />} />
                            <Route path="volunteers" element={<AdminVolunteers />} />
                            <Route path="analytics" element={<AdminAnalytics />} />
                            <Route path="intelligence" element={<AdminIntelligence />} />
                            <Route path="analytics-settings" element={<AdminAnalyticsSettings />} />
                            <Route path="brand-assets" element={<AdminBrandAssets />} />
                            <Route path="impact-stats" element={<AdminImpactStats />} />
                            <Route path="impact-metrics" element={<AdminImpactMetrics />} />
                            <Route path="programme-funding" element={<AdminProgrammeFunding />} />
                            <Route path="projects" element={<AdminProjects />} />
                            <Route path="media-inventory" element={<AdminMediaInventory />} />
                            <Route path="impact-snapshot" element={<AdminImpactSnapshot />} />
                            <Route path="users" element={<AdminUsers />} />
                            <Route path="security" element={<AdminSecurity />} />
                        </Route>

                        <Route path="*" element={P(NotFound)} />
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
